export const ROUTES_MAP: any = {
  login: 'login',
  profile: 'profile',
  invitations: 'invitations',
  sessions: 'sessions',
  analytics: 'analytics',
  offerData: 'offer-data',
  productValidation: 'product-validation',
  dashboard: 'dashboard',
  users: 'users',
  resetPassword: 'resetpassword'
};
